"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Container = void 0;
var _react = require("react");
var _FullScreenContext = _interopRequireDefault(require("./FullScreenContext"));
var _styles = require("@gogame/ui/styles");
var _clsx2 = _interopRequireDefault(require("clsx"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["withColorScale", "children"],
  _excluded2 = ["children", "minHeight", "hasRows", "fullScreen", "onToggle", "className", "withColorScale", "component"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      flex: 1,
      position: 'relative',
      minHeight: function minHeight(_ref) {
        var _minHeight = _ref.minHeight;
        return _minHeight;
      },
      '& ::-webkit-scrollbar': {
        background: theme.palette.background.paper + '!important'
      },
      '& ::-webkit-scrollbar-track:vertical': {
        borderLeft: function borderLeft(_ref2) {
          var hasRows = _ref2.hasRows;
          return hasRows ? "1px solid ".concat(theme.palette.divider) : 'none';
        }
      },
      '& ::-webkit-scrollbar-track:horizontal': {
        borderTop: function borderTop(_ref3) {
          var hasRows = _ref3.hasRows;
          return hasRows ? "1px solid ".concat(theme.palette.divider) : 'none';
        }
      }
    },
    fullScreen: {
      position: 'fixed',
      top: 64,
      left: 64,
      right: 0,
      bottom: 0,
      margin: '-1px 16px 16px !important',
      zIndex: 10,
      minHeight: '0 !important' // ignore min height for fullscreen
    },
    holder: {
      position: 'absolute',
      inset: 0,
      display: 'flex',
      flexFlow: 'column'
    }
  };
}, {
  name: 'DataGridContainer'
});
var defaultContainerComponent = function defaultContainerComponent(_ref4) {
  var _ = _ref4.withColorScale,
    children = _ref4.children,
    props = _objectWithoutProperties(_ref4, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", _objectSpread(_objectSpread({}, props), {}, {
    children: children
  }));
};
var Container = exports.Container = /*#__PURE__*/(0, _react.forwardRef)(function (_ref5, ref) {
  var children = _ref5.children,
    minHeight = _ref5.minHeight,
    hasRows = _ref5.hasRows,
    controlled = _ref5.fullScreen,
    onToggle = _ref5.onToggle,
    className = _ref5.className,
    withColorScale = _ref5.withColorScale,
    _ref5$component = _ref5.component,
    component = _ref5$component === void 0 ? defaultContainerComponent : _ref5$component,
    props = _objectWithoutProperties(_ref5, _excluded2);
  var classes = useStyles({
    minHeight: minHeight,
    hasRows: hasRows
  });
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    fullScreenState = _useState2[0],
    setFullScreenState = _useState2[1];
  var isControlled = controlled !== undefined;
  var fullScreen = isControlled ? controlled : fullScreenState;
  var handleToggleFullScreen = function handleToggleFullScreen() {
    var nextFullScreen = !fullScreen;
    if (!isControlled) {
      setFullScreenState(nextFullScreen);
    }
    onToggle === null || onToggle === void 0 || onToggle(nextFullScreen);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_FullScreenContext["default"].Provider, {
    value: {
      fullScreen: fullScreen,
      toggle: handleToggleFullScreen
    },
    children: /*#__PURE__*/(0, _react.createElement)(component, _objectSpread(_objectSpread({}, props), {}, {
      withColorScale: withColorScale,
      className: (0, _clsx2["default"])(classes.root, className, _defineProperty({}, classes.fullScreen, fullScreen))
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: classes.holder,
      ref: ref,
      children: children
    }))
  });
});
Container.displayName = 'Container';
var _default = exports["default"] = Container;